export interface ConfigResponseModel<T> {
  key: string;
  object: T;
  value: string;
}
